/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
'use strict';

const { ResponsiveCarouselConfig, PDPMainCarouselConfig, PDPThumbnailCarouselConfig,
	RecommendationCarouselConfig, SimilarItemCarouselConfig ,UpsellRecommendationCarouselConfig} = require('./carouselConfig.js');
let zoomViewer;

/**
 * initialize s7viewer to zoom in/out pdp images.
 * unbind the hover after initialization
 */
function zoomImg() {
	if($('.slider-main .slick-active img').data('zoominit')) {
		var zoomViewer,
			viewerConfig;
		if ($(window).width() <= 768) {
			viewerConfig = window.SitePreferences.SCENE7_CYO_CONFIG;
			zoomViewer = new s7viewers.MixedMediaViewer({
				'containerId': 's7viewer',
				'params': {
					'asset': $('.slider-main .slick-active img').data('assetid'),
					'serverurl': 'https://jamesavery.scene7.com/is/image/',
					'videoserverurl': 'https://jamesavery.scene7.com/is/content/',
					'config': 'JamesAvery/' + viewerConfig,
					'FlyoutZoomView.tip': '0,0,0.0',
					'contenturl': 'https://jamesavery.scene7.com/is/content/',
					'Swatches.align': 'center,bottom'
				},
				'handlers':{
					'initComplete':function() {
						$('.slider-main .slick-current img').unbind('mouseenter mouseleave');
					}
				}
			});
		} else {
			viewerConfig = window.SitePreferences.SCENE7_PDP_CONFIG;
			zoomViewer = new s7viewers.MixedMediaViewer({
				'containerId': 's7viewer',
				'params': {
					'asset': $('.slider-main .slick-active img').data('assetid'),
					'serverurl':'https://jamesavery.scene7.com/is/image/',
					'videoserverurl':'https://jamesavery.scene7.com/is/content/',
					'config': 'JamesAvery/' + viewerConfig,
					'Swatches.align': 'left,top',
					'Swatches.tmblayout': '1,0',
					'FlyoutZoomView.tip': '0,0,0.0',
					'contenturl': 'https://jamesavery.scene7.com/is/content/'
				},
				'handlers':{
					'initComplete':function() {
						$('.slider-main .slick-current img').unbind('mouseenter mouseleave');
					}
				}
			});
		}
		zoomViewer.init();
	}
}

function dynamicImpressionTrackingCrossSell() {
	if ('IntersectionObserver' in window) {
		let slickSliders = document.querySelectorAll('.slick-slide .product');
		let config = {
			root: null,
			rootMargin: '0px',
			threshold: 0.0
		};

		let observer = new IntersectionObserver(onChange, config);
		slickSliders.forEach(slider => observer.observe(slider));

		// eslint-disable-next-line no-inner-declarations
		function onChange(elements, observer) {
			elements.forEach(element => {
				var viewed  = $(element.target).attr('data-viewed');
				if(element.isIntersecting && !viewed) {
					var target = $(element.target);
					var carouselTitle = target.closest('.recommendations').find('.gtm-text').text().trim();			
					var gtmData = target.find('.product-click-track').data('gtm-data');
					if(gtmData){
						var positionInSlick = target.parents('.slick-slide').data('slick-index');
						let positionObject = {position : parseInt(positionInSlick) + 1,list : carouselTitle ? carouselTitle : gtmData.category};
						Object.assign(gtmData, positionObject);
						$(document).trigger('crossSell:trackDynamicImpression', { gtmData: JSON.stringify(gtmData) });
					}
					$(element.target).attr('data-viewed',true);
					observer.unobserve(element.target);
				}
			});
		}
	}
}

/**
 * creates carousel and binds mouseover on image change
 * @param {mainClass} className - class name of the main carousel
 * @param {mainConfig} carouselConfig - main carousel configuration
 * @param {thumbnailClass} className - class name of the thumbnail carousel
 * @param {thumbnailConfig} thumbnailConfig - left nav thumbnail carousel configuration
 */
function createCarousel(mainClass, mainConfig, thumbnailClass = '', thumbnailConfig = {}) {
	zoomViewer && zoomViewer.dispose();
	$('.removeactivescript').children().each(function(index, ele){
		if($(ele)[0].nodeName == 'SCRIPT'){
			$(ele).remove();
		}
	});
	if (mainClass && $(`.${mainClass}`)[0]) {
		$(`.${mainClass}`).not('.slick-initialized').slick(mainConfig);
	}

	if($('.cartRecommendationCarousel').hasClass('show-cart-slick')){
		$('.cartRecommendationCarousel').removeClass('show-cart-slick');	
	}

	if (thumbnailClass && $(`.${thumbnailClass}`)[0]) {
		$(`.${thumbnailClass}`).not('.slick-initialized').slick(thumbnailConfig);

		$(`.${thumbnailClass} .slick-slide`).on('click', function () {
			$(`.${mainClass}`).slick('slickGoTo', $(this).data('slickIndex'));
		});
		$(`.${mainClass} img`).mouseenter(function() {
			zoomImg();
		});

		$(`.${mainClass}`).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			zoomViewer && zoomViewer.dispose();
			$(`.${mainClass} .slick-current img`).bind('mouseenter', (function () {
				zoomImg();
			}));
			$(`.${thumbnailClass}`).find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
		});
	}

	if(mainClass == 'slider-main' || mainClass == 'cartRecommendationCarousel' || mainClass == 'flyout-carousel'){
		dynamicImpressionTrackingCrossSell();
	}
}


module.exports = {
	pdpCarousel: function() {
		createCarousel('slider-main', PDPMainCarouselConfig, 'slider-nav', PDPThumbnailCarouselConfig);
	},
	searchCarousel: function() {
		createCarousel('plpCarousel', ResponsiveCarouselConfig);
	},
	cartCarousel: function() {
		window.addEventListener('einsteinCarouselLoaded', function() {
			createCarousel('cartRecommendationCarousel', RecommendationCarouselConfig, 'slpSimilarCarousel', SimilarItemCarouselConfig);
			createCarousel('cartUpsellRecommendationCarousel',UpsellRecommendationCarouselConfig);
		});
		if($('.cartRecommendationCarousel:not(.slick-initialized)').length > 0) {
			createCarousel('cartRecommendationCarousel', RecommendationCarouselConfig);
		}
	},
	renderUpSellCarousel : function(){
		createCarousel('cartUpsellRecommendationCarousel',UpsellRecommendationCarouselConfig);
	},
	customCarousel: createCarousel
};
 